import React from 'react';

import {
 Label,
 Input,
 Button,
 FormFeedback
} from "reactstrap";

import '../assets/scss/custom/components/_ito_button.scss';

export const FormInput = ({ 
     register, 
     id, 
     label, 
     name, 
     validation,
     OnChangeCustom, 
     ...rest 
}) => {

    const {  onChange , ref, ...registerField } = register(name, validation);

    return (
      <>
      <Label htmlFor={id}>{label}</Label>
      <Input
          innerRef={ref}

          onChange = { (e) => { 
               OnChangeCustom && OnChangeCustom(e);
               onChange(e) 
          } }

          {...registerField} id={id} 
          {...rest} 
      />
     </>
     )
  };


export const FormMessage = ({children}) => {

  return (
     <FormFeedback>
          {children}
      </FormFeedback>
  )

 }


export const FormError = ({message}) => { 
    return <h6 className='mt-1 mb-0 text-danger'>{message}</h6>
}

export const RenderErrors = ({errors}) => {
  console.log('RenderErrors')
  console.log(errors)
  return (
    <>
    {
      Object.keys(errors).map((k, index)=> {  
        return (
          <>
            <h6 className='mb-0 text-danger' key={k}>{k}</h6>
          { Array.isArray(errors[k]) ?  (
                <ul key={index} className='mt-0 text-danger'>
                   {
                     errors[k].map((ele , j)=> <li key={j}>{ele}</li>)
                   }
                </ul>
         ) :  <span className='mt-0 text-danger'>{errors[k]}</span> }
          </>
        )
      })
    }
   </>
  )
}


export const SubmitButton = ({label, action}) => {
  return (
    <Button  className='ito_btn' onClick={action}>{label}</Button>
  )
 }

